import { createFileRoute } from '@tanstack/react-router'
import { AssetsAllPage } from '../../../components/AssetsPage'

export const Route = createFileRoute('/$org/assets/all')({
    component: AssetsIndex,
    validateSearch: (search: Record<string, unknown>) => {
        return {
            asset_type_uid: search.asset_type_uid as string | undefined,
        }
    },
})

function AssetsIndex() {
    return <AssetsAllPage />
}